import { ComponentTypesV2 } from 'opensolar-common'
import { COMPONENT_TYPE_OPTIONS } from 'resources/components/others/constants'
import { isMountingComponent } from 'util/misc'
import { BomComponentSelectorType } from './AddItemDialog'

/** Resolves `types` filter values for componentsv2 when browsing from the BOM component selector. */
export const getComponentSelectorBrowseTypes = (componentType: BomComponentSelectorType): ComponentTypesV2[] => {
  if (componentType === 'other') {
    return COMPONENT_TYPE_OPTIONS.filter((option) => !isMountingComponent(option.id)).map((option) => option.id)
  }
  if (componentType === 'mounting') {
    return COMPONENT_TYPE_OPTIONS.filter((option) => isMountingComponent(option.id)).map((option) => option.id)
  }
  return [componentType]
}
